import React from "react";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import HeroButton from "/app/src/components/HeroUi/Button";

/**
 * Controls component renders the controls for workflow management.
 *
 * @param {object} props - The properties for the Controls component.
 * @param {boolean} props.activeNewWorkflow - Indicates if a new workflow is active.
 * @param {function} props.toggleNewWorkflow - Function to toggle the new workflow state.
 * @returns {JSX.Element} The JSX for the workflow controls.
 */
export default function Controls({
  activeNewWorkflow,
  toggleNewWorkflow,
}: {
  activeNewWorkflow: boolean;
  toggleNewWorkflow: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="controls">
      <Row>
        <Col span={8}>
          <h1>{t("translation:all_workflows")}</h1>
        </Col>
        <Col span={16}>
          <div className="controlButtons">
            {activeNewWorkflow ? (
              <HeroButton
                size="sm"
                variant="bordered"
                color="primary"
                onClick={toggleNewWorkflow}
                className="hover:border-primary-default hover:text-primary-default bg-white"
              >
                {t("translation:cancel")}
              </HeroButton>
            ) : (
              <HeroButton size="sm" color="primary" onClick={toggleNewWorkflow}>
                {t("translation:new_workflow")}
              </HeroButton>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}
